export default function auth({ next, store }){
    if(!store.getters['users/isAuth']){
        return next({
           name: 'home'
        });
    }

    return next();
}